import { z } from 'zod';
import { ISimulationPayload } from '../types';
import { addIssue } from './helpers/add-issue';

export const validateStep1CommercialGroup = (
  data: ISimulationPayload,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
): boolean => {
  let hasErrors = false;
  const { leadInfo } = data.inputs?.parsedPayload || {};
  const parsedPayload = data.inputs?.parsedPayload;

  if (!leadInfo?.leadId) {
    addIssue(ctx, ['inputs', 'parsedPayload', 'leadInfo', 'leadId'], 'Grupo Comercial é obrigatório');
    hasErrors = true;
  }

  if (!leadInfo?.name) {
    addIssue(ctx, ['inputs', 'parsedPayload', 'leadInfo', 'name'], 'Nome do grupo é obrigatório');
    hasErrors = true;
  }

  if (!leadInfo?.docNumber) {
    addIssue(ctx, ['inputs', 'parsedPayload', 'leadInfo', 'docNumber'], 'Documento é obrigatório');
    hasErrors = true;
  }

  if (!parsedPayload?.aux__useDifferentPeriodsByUnit) {
    if (!parsedPayload?.aux__useGlobalSupplyStartDate) {
      addIssue(
        ctx,
        ['inputs', 'parsedPayload', 'aux__useGlobalSupplyStartDate'],
        'Data de início do contrato é obrigatória',
      );
      hasErrors = true;
    }

    if (!parsedPayload?.aux__useGlobalSupplyFinalDate) {
      addIssue(
        ctx,
        ['inputs', 'parsedPayload', 'aux__useGlobalSupplyFinalDate'],
        'Data de término do contrato é obrigatória.',
      );
      hasErrors = true;
    }

    if (parsedPayload?.aux__useGlobalSupplyStartDate && parsedPayload?.aux__useGlobalSupplyFinalDate) {
      const startDate = new Date(parsedPayload.aux__useGlobalSupplyStartDate);
      const endDate = new Date(parsedPayload.aux__useGlobalSupplyFinalDate);

      if (endDate <= startDate) {
        addIssue(
          ctx,
          ['inputs', 'parsedPayload', 'aux__useGlobalSupplyFinalDate'],
          'Data de término deve ser maior que data de início',
        );
        hasErrors = true;
      }
    }
  }

  return !hasErrors;
};
